export default {
  // Navigation menu
  nav: {
    home: "Home",
    about: "About Us",
    product: "Products",
    productDetail: "Product Detail",
    strength: "Comprehensive Strength",
    comparison: "Market Comparison",
    contact: "Contact Us",

    companyIntro: "Company Profile",
    culture: "Culture",
    recruitment: "Recruitment",
    news: "News",
    newsDetail: "News Detail",
    honors: "Honors",

    qualityAssurance: "Quality Assurance",
    innovation: "R&D and Innovation",
    SmartManufacturing: "Smart Manufacturing",
    laboratory: "Laboratory",

    wechat: {
      introduction: "Company Profile",
      product: "Products",
      productDetail: "Product Details",
      applicationResume: "Application Resume",
    },
  },
  // Footer
  footer: {
    copyright: "浙ICP备2026040594号",
    TechnicalSupport: "Technical Support: Information Department.",
    company: "Copyright ©: HCB Industrial Connectors Co., Ltd.",
    logoTitle: "Industrial Connector Solutions Expert",
    phone: "Tel",
    email: "Email",
    address: "Address",
    fax: "Fax",
    phoneNumber: "0086-0577-62351197",
    emailNumber: "sd11{'@'}hcb.com.cn",
    addressNumber:
      "No. 4, Innovation Road, Leqing Bay Port Area, Leqing City, Zhejiang Province",
    faxNumber: "0086-0577-62363197",
  },
  // Home Page
  Home: {
    hero: {
      title: "Connector Industry Technical Expert",
      subtitle:
        "Yueqing Changdecheng Electronics Co., Ltd. was established in 1991 and is one of China's leading connector experts, providing high-quality connection solutions for the automotive and home appliance industries.",
      button: "Learn More",
    },
    products: {
      title: "Product Center",
      searchPlaceholder: "Please enter product model or keyword",
      searchButton: "Search",
      more: "More >",
      hotTag: "Hot Product",
    },
    company: {
      title: "About Us",
      content: [
        "HCB Changdecheng was founded in 1991. It specializes in the research and manufacturing of precision connectors. It is a national high-tech enterprise, a national specialized and innovative 'small giant' enterprise, and a provincial-level green factory. ",
        "The company's products cover various application scenarios such as household appliances, automotive electronics, photovoltaic energy storage, consumer electronics, and industrial automation. Currently, it has established long-term cooperative relationships with many renowned domestic and foreign enterprises including Haier, Midea, Beike, Chery, and Changan. It has a provincial-level research and development center and a national CNAS-accredited laboratory. It has successively obtained authoritative system certifications such as IATF16949, ISO9001, ISO14001, ISO45001, and ISO50001, and possesses the one-stop supporting capabilities for the entire industrial chain, including customer demand research, solution customization, self-developed mold development, and large-scale production and delivery. ",
        "Relying on its profound precision connection technology, Changdecheng continues to empower the smart industry and intelligent life, providing high-reliability connector overall solutions, and striving to become a trusted partner in the global electronic connector industry.",
      ],
      stats: {
        experience: "Years of Industry Experience",
        factory: "Square Meters Factory",
        employees: "Professional Employees",
        customers: "Global Customers",
      },
    },
    industry: {
      title: "Industry & Applications",
      categories: [
        "Home Appliance Industry",
        "Automotive Industry",
        "New Energy Industry",
        "Robot Industry",
      ],
    },
    news: {
      title: "News Center",
    },
  },

  // 关于我们
  About: {
    title: "About Us",
    tabs: "Expert in industrial connector solutions",
    recruitment: {
      jobCount: "Found {count} job listings",
      contact: "0577-62521899 Manager Jin",
      title: "CAREER OPPORTUNITIES",
      content: "Join us and create the future together",
      stats: {
        label: "Open for applications",
        location: "YueQing City",
        fullTime: "Full-Time",
      },
      recruitment: "Recruitment ",
      person: " Person",
      welfare: {
        title: "Compensation & Benefits",
        salary: {
          title: "Salary Package",
          desc: "One-day weekend system. Piece-rate wages and overtime pay are calculated separately. Full attendance, seniority, position, performance, quality awards, and housing subsidies available. Paid Spring Festival leave and full pay on statutory holidays.",
        },
        insurance: {
          title: "Social Insurance",
          desc: "Comply with the national regulations to handle pension insurance, medical insurance, unemployment insurance, work-related injury insurance, maternity insurance and housing provident fund (five insurances and one fund).",
        },
        festival: {
          title: "Holiday Benefits",
          desc: "Traditional festivals offer festival benefits and other rewards; regular employee training sessions, outdoor adventure tours, and sports competitions are organized; regular staff dinners, gatherings, and other activities are held.",
        },
        other: {
          title: "Living Facilities",
          desc: "Well-equipped dormitories with double rooms (couples' rooms included), A/C, hot water, private bathroom, internet — move-in ready. Canteen serves clean, varied meals. Free lunch for day shift, night meal subsidy for night shift overtime.",
        },
      },
      emptyData: {
        text: "There are currently no available job openings.",
        subtext: "Please come back later to check.",
      },
    },
    companyDetails: {
      title: "About Us",
      stats: {
        experience: "Years of Industry Experience",
        factory: "Square Meters Factory",
        employees: "Professional Employees",
        customers: "Global Customers",
        terminals: "100M+ Terminals/Year",
      },
      content: [
        "HCB Changdecheng was founded in 1991. It specializes in the research and manufacturing of precision connectors. It is a national high-tech enterprise, a national specialized and innovative 'small giant' enterprise, and a provincial-level green factory. ",
        "The company's products cover various application scenarios such as household appliances, automotive electronics, photovoltaic energy storage, consumer electronics, and industrial automation. Currently, it has established long-term cooperative relationships with many renowned domestic and foreign enterprises including Haier, Midea, Beike, Chery, and Changan. It has a provincial-level research and development center and a national CNAS-accredited laboratory. It has successively obtained authoritative system certifications such as IATF16949, ISO9001, ISO14001, ISO45001, and ISO50001, and possesses the one-stop supporting capabilities for the entire industrial chain, including customer demand research, solution customization, self-developed mold development, and large-scale production and delivery. ",
        "Relying on its profound precision connection technology, Changdecheng continues to empower the smart industry and intelligent life, providing high-reliability connector overall solutions, and striving to become a trusted partner in the global electronic connector industry.",
      ],
    },
    history: {
      title: "Development History",
      items: [
        {
          year: 1991,
          title: "Company Establishment",
          content:
            "Hongqiao Electric Porcelain Switch Factory was formally established, taking the first step in the connection field and laying the foundation for enterprise development.",
        },
        {
          year: 1993,
          title: "Honor Road",
          content:
            "Received the title of Advanced Enterprise in Yueqing City, beginning to emerge in the industry.",
        },
        {
          year: 1999,
          title: "Brand Strategy",
          content:
            "Registered the HCB brand and began to implement brand strategy to enhance market influence.",
        },
        {
          year: 2001,
          title: "System Certification",
          content:
            "Passed ISO9001 quality management system certification, and product quality was recognized internationally.",
        },
        {
          year: 2003,
          title: "Expanded Production",
          content:
            "Factory area expanded, advanced production equipment introduced, and production capacity increased significantly.",
        },
        {
          year: 2006,
          title: "R&D Investment",
          content:
            "Established R&D center, increased technical R&D investment, and enhanced independent innovation capability.",
        },
        {
          year: 2017,
          title: "Strategic Transformation",
          content:
            "Implemented automation transformation, promoted intelligent manufacturing, and improved production efficiency.",
        },
        {
          year: 2020,
          title: "Rapid Development",
          content:
            "Built a digital intelligent factory, realizing intelligent management of the entire production process.",
        },
        {
          year: 2025,
          title: "Technology Center",
          content:
            "Recognized as a Zhejiang Provincial Enterprise Technology Center, and its technological R&D capability was officially recognized.",
        },
      ],
    },
    certifications: {
      title: "Certifications",
      items: [
        {
          title: "ISO9001",
          desc: "Quality Management System Certification",
        },
        {
          title: "ISO50001",
          desc: "Energy Management System Certification",
        },
        {
          title: "ISO14001",
          desc: "Environmental Management System Certification",
        },
        {
          title: "ISO45001",
          desc: "Occupational Health and Safety Management System Certification",
        },
        {
          title: "IATF16949",
          desc: "Automotive Industry Quality Management System Certification",
        },
      ],
    },
    partners: {
      title: "Partners",
    },
    honors: {
      title: "Corporate Honors",
      description:
        "Our company has received a number of honors, demonstrating our leading position in the industry.",
    },
    culture: {
      values: {
        title: "Core Values",
        items: [
          {
            title: "Corporate Mission",
            content: "Only for connecting the beauty of life",
          },
          {
            title: "Corporate Vision",
            content: "Building a world-class electronic connector brand",
          },
          {
            title: "Core Values",
            content: "Innovation, Excellence, Integrity, Win-Win",
          },
        ],
      },
      concepts: {
        title: "Business Philosophy",
        items: [
          {
            title: "Business Policy",
            content: "Take off with quality, soar with technology",
          },
          {
            title: "Quality Policy",
            content:
              "People-oriented, quality-oriented, continuous improvement, customer satisfaction",
          },
        ],
      },
      details: {
        title: "Core Values Details",
        items: [
          {
            title: "Innovation",
            content:
              "Continuously explore new technologies and methods, promote innovation in products and services, and maintain the company's competitiveness and vitality. We encourage employees to put forward new ideas, dare to try, and constantly break through themselves in innovation.",
          },
          {
            title: "Excellence",
            content:
              "Pursue excellent quality, continuously improve the quality of products and services, and strive to be industry-leading. We strive for excellence in every detail, demand ourselves with high standards, and provide customers with the best products and services.",
          },
          {
            title: "Integrity",
            content:
              "Be honest and trustworthy, abide by business ethics, and establish a good corporate image and brand reputation. We insist on keeping our word, remain honest and transparent to customers, employees and partners, and win trust with integrity.",
          },
          {
            title: "Win-Win",
            content:
              "Establish mutually beneficial and win-win relationships with customers, employees and partners for common development. We believe that only through cooperation and sharing can we achieve sustainable development and create greater value.",
          },
        ],
      },
      practice: {
        title: "Corporate Culture Practice",
        content: [
          "We integrate corporate culture into every aspect of daily work, through various activities and practices, making corporate culture truly become the driving force for enterprise development and the criterion for employee behavior.",
          "From product research and development to customer service, from employee training to team building, we always uphold the core values and strive to create a positive and vibrant corporate atmosphere.",
        ],
      },
    },
  },

  // 产品中心
  Products: {
    title: "Automotive connector",
    banner: "Industrial Connector Solutions",
    filter: "Filter Conditions",
    productLine: "Product Line",
    series: "Series",
    type: "Type",
    wireGauge: "Applicable Wiring Regulations",
    surfaceTreatment: "Surface Treatment",
    color: "Color",
    Spacing: "Spacing(mm)",
    Digits: "Digits",
    NumberRows: "Line Number",
    clear: "Clear Filters",
    product: "Product",
    pagination: {
      total: "Total",
      items: "items",
      go: "Go to",
      page: "page",
    },
    loading: "Data loading...",
    NoData: "No data available",
    image: "Product image",
    fields: {
      productCode: "Product Code",
      productLine: "Product Line",
      series: "Series",
      specification: "Specification",
      type: "Type",
      spacing: "Spacing",
      digits: "Digits",
      numberRows: "Number of Rows",
      mountingDirection: "Mounting Direction",
      wireGauge: "Wire Gauge",
      ratedPlating: "Rated Current",
      materialThickness: "Material Thickness",
      insertThickness: "Insert Thickness",
      boltSize: "Bolt Size",
      color: "Color",
      ratedVoltage: "Rated Voltage",
      material: "Material",
      surfaceTreatment: "Surface Treatment",
      environmentUse: "Environment Use",
      competitorInfo: "Competitor Information",
      minPackageQuantity: "Package Quantity",
      packagingType: "Packaging Type",
    },
    Drawing: "Customer Drawing (PDF)",
    Specification: "Product Specification (PDF)",
    search: "Search",
    placeholder: "Search for products...",
    searchCode: "The same part number search...",
    details: {
      title: "Product Information Card",
      actionButtons: "Action Buttons",
      productSpec: "Product Specification (PDF)",
      model3d: "3D Model",
      relatedProducts: "Related Products",
      supportingProducts: "All Supporting Products ({count})",
      noSupportingProducts: "No supporting products available",
      viewProduct: "View Product",
      pairedProducts: "Paired Products ({count})",
      noPairedProducts: "No paired products available",
      viewModel: "View {title} Model",
      noPdfAvailable: "No PDF document available",
      retryLoad: "Retry loading",
    },
  },

  // 综合实力
  Strength: {
    title: "Comprehensive Strength",
    qualityAssurance: {
      title: "Quality Assurance",
      description:
        "We adhere to quality as the center, established a sound quality management system, ensuring every product meets high standard requirements.",
      items: [
        {
          title: "Quality Management System",
          content:
            "Passed ISO9001, IATF16949 and other international certifications, established a sound quality management system",
        },
        {
          title: "Raw Material Control",
          content:
            "Strict raw material procurement and inspection processes to ensure raw material quality",
        },
        {
          title: "Production Process Control",
          content:
            "Automated production equipment, real-time monitoring of production processes to ensure product consistency",
        },
        {
          title: "Finished Product Inspection",
          content:
            "Strict finished product inspection processes to ensure every product meets standards",
        },
        {
          title: "Continuous Improvement",
          content:
            "Regular quality analysis and improvement to continuously enhance product quality",
        },
        {
          title: "Customer Satisfaction",
          content:
            "Regular customer satisfaction surveys to continuously improve service quality",
        },
      ],
    },
    innovation: {
      title: "R&D and Innovation",
      rndTeam: {
        title: "R&D Team",
        description:
          "We have a professional R&D team dedicated to innovation and development of connector technology",
        orgChart: {
          title: "R&D Team",
          levels: [
            [
              {
                name: "Product R&D Team",
                size: "28 people",
              },
              {
                name: "Mold R&D Team",
                size: "105 people",
              },
              {
                name: "Automation R&D",
                size: "5 people",
              },
            ],
            [
              {
                name: "Mold Design",
                size: "45 people",
              },
              {
                name: "Processing Center",
                size: "60 people",
              },
            ],
          ],
          footer:
            "Provincial Enterprise R&D Center, Wenzhou Enterprise Technology Center",
        },
        investment: {
          title: "R&D Investment",
          description:
            "Always maintain high investment to ensure the company maintains a leading position in technological innovation and product R&D.",
          imageAlt: "Advanced Enterprise in R&D Investment",
        },
      },
      patents: {
        title: "Patent Technology",
        description:
          "Possesses multiple connector-related patent technologies with strong technical strength",
      },
    },
    smartManufacturing: {
      title: "Smart Manufacturing",
      description:
        "We are committed to building smart factories by introducing advanced smart manufacturing technologies to achieve automation, digitization and intelligence in the production process, improving production efficiency and product quality.",
      items: [
        {
          title: "AGV Automated Handling",
          content:
            "Adopt advanced AGV (Automated Guided Vehicle) system to realize automated material handling, reduce manual operations, and improve handling efficiency and accuracy.",
          imageAlt: "AGV Automated Handling",
        },
        {
          title: "Smart Warehouse",
          content:
            "Establish smart stereoscopic warehouse to realize automated storage and retrieval of materials, improve warehouse space utilization and material management efficiency.",
          imageAlt: "Smart Warehouse",
        },
        {
          title: "Automation Equipment",
          content:
            "Introduce advanced automated production equipment to realize automated control of the production process, improve production efficiency and product quality.",
          imageAlt: "Automation Equipment",
        },
        {
          title: "Real-time Monitoring System",
          content:
            "Establish real-time monitoring system to monitor the entire production process, timely discover and solve problems in production, and ensure product quality.",
          imageAlt: "Real-time Monitoring System",
        },
      ],
    },
    laboratory: {
      title: "Laboratory",
      description:
        "We have advanced laboratories to provide technical support for product R&D and quality control.",
      items: [
        {
          title: "Laboratory Facilities",
          content:
            "Possess advanced laboratory equipment to provide technical support for product R&D",
        },
        {
          title: "Product Testing",
          content: "Strict product testing process to ensure product quality",
        },
        {
          title: "Standard Certification",
          content:
            "Meet international standard requirements, product quality is guaranteed",
        },
        {
          title: "Technical Research",
          content:
            "Carry out connector technology research to promote industry development",
        },
      ],
    },
  },

  //市场同类产品对照
  ProductComparison: {
    title: "Market Similar Products Comparison",
    searchPlaceholder: "Please enter product model or keyword...",
    searchButton: "Search",
    tableHeaders: {
      brand: "Brand",
      picture: "Picture",
      product: "HCB Similar Product",
      description: "Product Parameters",
    },
  },

  // 联系我们
  Contact: {
    banner: "Contact Us",
    info: "Contact Information",
    form: "Message Inquiry",
    name: "Name",
    email: "Email",
    phone: "Phone",
    message: "Message Content",
    submit: "Submit",
    submitting: "Submitting...",
    submitSuccess:
      "Submission successful! We will contact you as soon as possible.",
    address:
      "No. 4, Innovation Road, Leqing Bay Port Area, Leqing City, Zhejiang Province",
    labels: {
      phone: "Phone: ",
      email: "Email: ",
      address: "Address: ",
      zip: "Zip Code: ",
    },
    errors: {
      name: "Please enter your name",
      email: "Please enter your email",
      emailInvalid: "Please enter a valid email address",
      phone: "Please enter your phone number",
      message: "Please enter your message",
    },
    mapTitle: "Old Company Location",
    newmapTitle: "New Company Location",
  },
  // 公司动态
  News: {
    more: "View More >",
    loading: "Loading...",
    noData: "No news data available",
  },
};
